<template>
  <div>
    <div v-for="(item,index) in dataList" class="item">
      <el-card shadow="always" style="height:100%;">
        <div class="title-box" style="width:80px;height:80px;">
          <div class="fate-image-container middle">
            <div :class="'txt-logo color-'+index%10">
              <span v-if="item.alias != null" class="txt-word-1">{{ item.alias }}</span>
              <span v-else class="txt-word-1">{{
                  item.company_name.replace('（', '').replace('）', '').substring(0, 4)
                }}</span></div>
          </div>
        </div>
        <div class="content-box" style="padding-left:100px;">
          <div class="title cursor-pointer p-0"><a @click="getInfoDetail(item)">{{
              item.company_name
            }}</a>
            <el-tag v-if="item.reg_status=='存续'" type="success">
              {{ item.reg_status }}
            </el-tag>
            <el-tag v-else-if="item.reg_status=='开业'" type="success">
              {{ item.reg_status }}
            </el-tag>
            <el-tag v-else type="warning">{{ item.reg_status }}</el-tag>
            <!--
            <el-link icon="el-icon-plus"
                     @click="dlg_ent_detail=true" :underline="false"
                     style="float:right;margin-top: -5px;">详情
            </el-link>
            <el-link icon="el-icon-plus"
                     @click="addSingleContacts(item)" :underline="false"
                     style="float:right;margin-top: -5px;">添加
            </el-link>
            -->
            <el-link icon="el-icon-search"
                     @click="getHumDetail(item)" :underline="false"
                     style="float:right;margin-top: -5px;font-size:15px;">查看联系人
            </el-link>
          </div>
          <div class="content">
            <el-tag v-for="(tag,v) in item.tags" :key="tag" class="mr-1 mb-1">{{ tag }}</el-tag>
          </div>
          <div class="content">
            <label class="w-300">统一社会信用代码：{{ item.uni_code }}</label>
            <label>注册号：{{ item.reg_code }}</label>
          </div>

          <div class="content">
            <label class="w-300">注册日期：{{ item.reg_date }}</label>
            <label>法人：{{ item.legal_person }}
              <a v-if="admin" @click="getHumDetail(item)"> (更多高管)</a>
            </label>
          </div>
          <div class="content">
            <label class="w-300">注册资金：{{ item.reg_capital }}</label>
            <label>实缴资金：{{ item.real_capital }}</label>
          </div>
          <div class="content">
            <label v-if="Array.isArray(item.phoneDec)" class="w-300">
              <span>电话：{{ item.phoneDec[0] }}</span>
              <el-popover v-if="item.phoneDec.length>1" placement="top" width="220" trigger="hover">
                <div v-for="(i,v) in item.phoneDec" class="p-1">
                  {{ i }}
                </div>
                <a slot="reference">更多&nbsp;{{ item.phoneDec.length }}</a>
              </el-popover>
            </label>
            <label v-else class="w-300">
              <span>电话：{{ item.phone }}</span>
            </label>

            <label v-if="Array.isArray(item.emailDec)">
              <span>邮箱：{{ item.emailDec[0] }}</span>
              <el-popover v-if="item.emailDec.length>1" placement="top" width="220" trigger="hover">
                <div v-for="(i,v) in item.emailDec" class="p-1">
                  {{ i }}
                </div>
                <a slot="reference">更多&nbsp;{{ item.emailDec.length }}</a>
              </el-popover>
            </label>
            <label v-else>
              <span>邮箱：{{ item.email }}</span>
            </label>
          </div>
          <div class="content">
            <label class="w-300">行业：{{ item.industry }}
            </label>
            <label>公司类型：{{ item.company_type }}
            </label>
          </div>
          <div class="content">
            <label>行业细分：{{ item.indus2+","+item.indus3 }}</label>
          </div>

          <div class="content">
            <label class="w-300">社保人数：{{ item.head_count }} 人
            </label>
            <label>规模：{{ item.staff_num }}
            </label>
            <label>
              {{ item.scale }}
              <el-dropdown trigger="click" @command="update_scale" v-if="sysAdmin">
                <span class="el-dropdown-link">
                  更新<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="before_update_scale('超大型',item)">超大型</el-dropdown-item>
                  <el-dropdown-item :command="before_update_scale('大型',item)">大型</el-dropdown-item>
                  <el-dropdown-item :command="before_update_scale('中型',item)">中型</el-dropdown-item>
                  <el-dropdown-item :command="before_update_scale('小型',item)">小型</el-dropdown-item>
                  <el-dropdown-item :command="before_update_scale('微型',item)">微型</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </label>
          </div>
          <div class="content">
            <label>地址：{{ item.address }}</label>
          </div>
          <div v-if="item.busi_scope" class="content">
            <div>经营范围：{{ get_substr(item.busi_scope) }}</div>
          </div>
        </div>
      </el-card>
    </div>

    <el-dialog title="详细信息" :visible.sync="dlg_detail" :close-on-click-modal="true"
               width="900px">
      <table class="index_tableBox__ZadJW">
        <tbody>
        <tr>
          <td>公司名</td>
          <td colspan="3">{{ ent_item.company_name }}</td>
        </tr>
        <tr>
          <td>统一社会信用代码<i class=""></i></td>
          <td>
            <div class=""><span class="">{{ ent_item.uni_code }}</span>
            </div>
          </td>
          <td>纳税人识别号<i class=""></i></td>
          <td>
            <span class="">{{ ent_item.uni_code }}</span>
          </td>
        </tr>
        <tr>
          <td>组织机构代码<i class=""></i></td>
          <td>
            <div class=""><span class="">{{ ent_item.org_number }}</span>
            </div>
          </td>
          <td width="">工商注册号<i class=""></i></td>
          <td width="">
            <div title="">{{ ent_item.reg_code }}</div>
          </td>
        </tr>
        <tr>
          <td>联系方式<i class=""></i></td>
          <td>
            <div class=""><span v-if="ent_item.phone" class="">{{ ent_item.phone.join('；') }}</span>
            </div>
          </td>
          <td>电子邮箱<i class=""></i></td>
          <td>
            <span v-if="ent_item.email" class="">{{ ent_item.email.join('；') }}</span>
          </td>
        </tr>
        <tr>
          <td rowspan="4" width="140px">法定代表人</td>
          <td rowspan="4" width="300px">{{ ent_item.legal_person }}</td>
          <td width="140px">经营状态</td>
          <td width="300px">{{ ent_item.reg_status }}</td>
        </tr>
        <tr>
          <td>评分</td>
          <td class="">
            <div class="">{{ Math.round(ent_item.score / 100) }}</div>
          </td>
        </tr>
        <tr>
          <td>成立日期</td>
          <td>{{ ent_item.reg_date }}</td>
        </tr>
        <tr>
          <td>核准日期</td>
          <td>{{ ent_item.appr_date|formatDateTime }}</td>
        </tr>
        <tr>
          <td>注册资本</td>
          <td>{{ ent_item.reg_capital }}</td>
          <td>实缴资本</td>
          <td>{{ ent_item.real_capital }}</td>
        </tr>
        <tr>
          <td>营业期限</td>
          <td><span>{{ ent_item.term }}</span></td>
          <td>纳税人资质</td>
          <td></td>
        </tr>
        <tr>
          <td>人员规模</td>
          <td>{{ ent_item.staff_num }}</td>
          <td>参保人数</td>
          <td>{{ ent_item.head_count }}</td>
        </tr>
        <tr>
          <td>企业类型</td>
          <td>{{ ent_item.company_type }}</td>
          <td>行业</td>
          <td>{{ ent_item.industry }}</td>
        </tr>

        <tr>
          <td>曾用名</td>
          <td>{{ ent_item.his_name }}</td>
          <td>英文名称</td>
          <td>
            {{ ent_item.en_name }}
          </td>
        </tr>
        <tr>
          <td>登记机关</td>
          <td colspan="3">
            <span class="">{{ ent_item.reg_inst }}</span>
          </td>
        </tr>
        <tr>
          <td>注册地址<i class=""></i></td>
          <td colspan="3">
            <span class="">{{ ent_item.address }}</span>
          </td>
        </tr>
        <tr>
          <td>经营范围<i class=""></i></td>
          <td colspan="3">
            {{ ent_item.busi_scope }}
          </td>
        </tr>
        </tbody>
      </table>

      <div v-if="staffList.length>0">
        <div class="form-title">主要人员</div>
        <div class="mb-2">
          <el-pagination layout="total, prev, pager, next" @current-change="handleChange_staff"
                         :page-size="this.s_page.size" :total="s_page.total" :current-page="s_page.index+1">
          </el-pagination>
        </div>
        <el-table stripe :data="staffList" border highlight-current>
          <el-table-column type="selection"></el-table-column>
          <el-table-column property="name" label="名称"></el-table-column>
          <el-table-column property="typeSore" label="职位"></el-table-column>
          <el-table-column property="percent" label="持股比例"></el-table-column>
          <el-table-column property="finalBenefitShares" label="最终受益股份"></el-table-column>
          <el-table-column property="adMd5" label="adMd5"></el-table-column>
          <el-table-column prop="link" label="详情" width="100">
            <template slot-scope="scope">
              <a href="javascript:void(0)" @click="getHumDetail(scope.row)">详情</a>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div v-if="holderList.length>0">
        <div class="form-title">股东信息</div>
        <div class="mb-2">
          <el-pagination layout="total, prev, pager, next" @current-change="handleChange_holder"
                         :page-size="this.h_page.size" :total="h_page.total" :current-page="h_page.index+1">
          </el-pagination>
        </div>
        <el-table stripe :data="holderList" border highlight-current v-loading="sub_table_loading">
          <el-table-column type="selection"></el-table-column>
          <el-table-column property="name" label="股东"></el-table-column>
          <el-table-column property="amount" label="认缴出资额"></el-table-column>
          <el-table-column property="capital[0].time" label="认缴出资日期"></el-table-column>
          <el-table-column property="finalBenefitShares" label="持股比例"></el-table-column>
          <el-table-column property="shareHolderType" label="类型"></el-table-column>
          <el-table-column prop="link" label="详情" width="100">
            <template slot-scope="scope">
              <a href="javascript:void(0)" @click="getEntDetail(scope.row.cid,scope.row.name)">详情</a>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div v-if="inverstList.length>0">
        <div class="form-title">投资信息</div>
        <div class="mb-2">
          <el-pagination layout="total, prev, pager, next" @current-change="handleChange_invest"
                         :page-size="this.i_page.size" :total="i_page.total" :current-page="i_page.index+1">
          </el-pagination>
        </div>
        <el-table stripe :data="inverstList" border highlight-current>
          <el-table-column type="selection"></el-table-column>
          <el-table-column property="name" label="被投资企业名称"></el-table-column>
          <el-table-column property="legalPersonName" label="法定代表人/执行事务合伙人"></el-table-column>
          <el-table-column prop="estiblishTime" label="成立日期" width="150">
            <template v-slot="scope">
              {{ scope.row.estiblishTime | formatDateTime }}
            </template>
          </el-table-column>
          <el-table-column property="amount" label="持股比例"></el-table-column>
          <el-table-column property="percent" label="持股比例"></el-table-column>
          <el-table-column property="regStatus" label="经营状态"></el-table-column>
        </el-table>
      </div>
      <div v-if="patentList.length>0">
        <div class="form-title">专利信息</div>
        <div class="mb-2">
          <el-pagination layout="total, prev, pager, next" @current-change="handleChange_ptn"
                         :page-size="this.p_page.size" :total="p_page.total" :current-page="p_page.index+1">
          </el-pagination>
        </div>
        <el-table stripe :data="patentList" border highlight-current
                  v-loading="sub_table_loading" @selection-change="selsChange">
          <el-table-column type="selection" width="50px"></el-table-column>
          <el-table-column property="applicationTime" label="申请日" width="100"></el-table-column>
          <el-table-column property="title" label="专利名称" width="200"></el-table-column>
          <el-table-column property="patentType" label="专利类型" width="100"></el-table-column>
          <el-table-column property="lprs" label="专利状态" width="100"></el-table-column>
          <el-table-column property="appnumber" label="申请号" width="120"></el-table-column>
          <el-table-column property="pubnumber" label="公布号" width="120"></el-table-column>
          <el-table-column property="pubDate" label="公告日" width="100"></el-table-column>
          <el-table-column property="inventor" label="发明人" width=""></el-table-column>
          <el-table-column prop="link" width="80">
            <template slot-scope="scope">
              <a href="javascript:void(0)" @click="getPatentDetail(scope.row)">详情</a>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-if="copyList.length>0">
        <div class="form-title">软件著作权</div>
        <div class="mb-2">
          <el-pagination layout="total, prev, pager, next" @current-change="handleChange_copyr"
                         :page-size="this.r_page.size" :total="r_page.total" :current-page="r_page.index+1">
          </el-pagination>
        </div>
        <el-table stripe :data="copyList" border highlight-current>
          <el-table-column type="selection" width="50px"></el-table-column>
          <el-table-column property="regtime" label="登记批准日期">
            <template v-slot="scope">
              {{ scope.row.regtime | formatDateTime }}
            </template>
          </el-table-column>
          <el-table-column property="fullname" label="软件全称"></el-table-column>
          <el-table-column property="simplename" label="软件简称"></el-table-column>
          <el-table-column property="regnum" label="登记号"></el-table-column>
          <el-table-column property="catnum" label="分类号"></el-table-column>
          <el-table-column property="version" label="版本号"></el-table-column>
          <el-table-column prop="publishtime" label="首次发表日期">
            <template v-slot="scope">
              {{ scope.row.publishtime | formatDateTime }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-if="copywList.length>0">
        <div class="form-title">作品著作权</div>
        <div class="mb-2">
          <el-pagination layout="total, prev, pager, next" @current-change="handleChange_copyw"
                         :page-size="this.w_page.size" :total="w_page.total" :current-page="w_page.index+1">
          </el-pagination>
        </div>
        <el-table stripe :data="copywList" border highlight-current>
          <el-table-column type="selection" width="50px"></el-table-column>
          <el-table-column property="fullname" label="作品名称"></el-table-column>
          <el-table-column property="regnum" label="登记号"></el-table-column>
          <el-table-column property="type" label="作品类别"></el-table-column>
          <el-table-column property="finishTime" label="创作完成日期"></el-table-column>
          <el-table-column property="createTime" label="登记日期"></el-table-column>
          <el-table-column property="publishtime" label="首次发表日期"></el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-drawer title="高管列表" :visible.sync="dlg_ent_hum_detail" size="500px">
      <div v-if="humlistLoading==false">
        <div v-if="ent_hum_list.length==0" class="h-420">
          <div class="loading_position" style="padding-top: 150px;">
            <span class="d-block">无数据</span>
          </div>
        </div>
        <div v-else>
          <h1 class="p-3" style='font-size: 18px;'>{{
              dlg_hum_detail_title + "（" + ent_hum_list.length + "）人"
            }}
          </h1>
        </div>
        <div v-for="(item,index) in ent_hum_list" class="pl-3 pb-3 pr-3">
          <el-card shadow="always" style="height:auto;">
            <div class="content-box" style="">
              <div class="title">
                <span style="cursor: pointer" @click="getInfoDetail(item)">{{ item.name }}</span>
              </div>
              <!--
              <div v-if="item.gender" class="content">
                <label v-if="item.gender=='female'">性别：女</label>
                <label v-else-if="item.gender=='male'">性别：男</label>
              </div>
              <div v-if="item.birthDay" class="content">
                <label>出生日期：{{ item.birthDay }}</label>
              </div>
              -->
              <div v-if="item.md5" class="content">
                <label style="cursor: pointer"
                       @click="getPhoneNumber(item.id,item.md5)">OneID：{{ item.md5.substr(0, 11) + "..." }}</label>
              </div>
              <div v-for="(md5,idx) in item.md5_list" class="content">
                <label @click="getPhoneNumber(item.id,md5)">OneID：{{ md5.substr(0, 11) + "..." }}</label>
              </div>
              <div v-if="item.typeJoin" class="content">
                <label>职位：<span v-for="(i,v) in item.typeJoin">{{ i.trim() }}
                        </span>
                </label>
              </div>
              <div v-if="item.share">
                <div>股份：{{ item.share }}</div>
              </div>
            </div>
          </el-card>
        </div>
      </div>
      <div v-else>
        <div class="h-420">
          <div class="loading_position" style="padding-top: 150px;">
            <i class="el-icon-loading" style="font-size: 25px;margin-left: 10px;margin-bottom: 10px;"></i>
            <span class="d-block">{{ loading_info }}</span>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import util from "../api/util"
import api from "../api/rest";
import PatentDetail from "./PatentDetail";

export default {
  components: {PatentDetail},
  props: {
    dataList: {
      type: Array,
      required: true,
      default: () => []
    },
    separator: String
  },
  data() {
    return {
      admin: false,
      sysAdmin: false,
      ent_item: {},
      pat_detail: {},
      orther_ent: {},
      dlg_detail: false,
      dlg_ptn_detail: false,
      dlg_ent_detail: false,
      dlg_hum_detail: false,
      dlg_ent_hum_detail: false,
      dlg_hum_detail_title: '公司名',
      dlg_doc: false,
      dlg_loading: false,
      sub_table_loading: false,
      hum_item: null,
      patentList: [],
      copyList: [],
      copywList: [],
      inverstList: [],
      staffList: [],
      folderList: [],
      holderList: [],
      ent_hum_list: [],
      page: {
        total: 0,
        index: 0,
        size: 10,
      },
      p_page: {
        total: 0,
        index: 0,
        size: 10,
      },
      h_page: {
        total: 0,
        index: 0,
        size: 10,
      },
      s_page: {
        total: 0,
        index: 0,
        size: 10,
      },
      i_page: {
        total: 0,
        index: 0,
        size: 10,
      },
      w_page: {
        total: 0,
        index: 0,
        size: 10,
      },
      r_page: {
        total: 0,
        index: 0,
        size: 10,
      },
      loading_info: '加载中...',
      listLoading: false,
      humlistLoading: false,
    }
  },
  methods: {
    clearData() {
      this.patentList = []
      this.copyList = []
      this.copywList = []
      this.inverstList = []
      this.staffList = []
      this.folderList = []
      this.holderList = []
      this.p_page = {
        total: 0,
        index: 0,
        size: 10,
      }
      this.p_page = {
        total: 0,
        index: 0,
        size: 10,
      }
      this.h_page = {
        total: 0,
        index: 0,
        size: 10,
      }
      this.s_page = {
        total: 0,
        index: 0,
        size: 10,
      }
      this.i_page = {
        total: 0,
        index: 0,
        size: 10,
      }
      this.w_page = {
        total: 0,
        index: 0,
        size: 10,
      }
      this.r_page = {
        total: 0,
        index: 0,
        size: 10,
      }
    },
    getEntDetail(cid) {
      this.dlg_ent_detail = true;
    },
    before_update_scale(val, doc) {
      return {
        "val": val,
        "doc": doc
      }
    },
    getPhoneNumber(hum_id, md5) {
      let para = {
        "id": hum_id,
        "md5": md5
      }
      let api_url = "/search/humPhoneDec"
      api.remote.doPost(para, api_url).then((res) => {
        console.log(res)
        if (res.status == 'error') {
          this.$message({
            title: '',
            message: res.message,
            type: res.status
          })
        } else {
          this.$message({
            title: '',
            message: res,
            type: 'success'
          })
        }
      }).catch((res) => {
        api.handError.action(this, res);
      });
    },
    update_scale(item) {
      let postData = {
        id: item['doc']['id'],
        scale: item['val']
      }
      console.log(postData)
      let api_url = '/search/update_scale'
      api.remote.doPost(postData, api_url).then((res) => {
        this.$message({
          message: res.message,
          type: "info",
        });
      }).catch((res) => {
        this.dlg_hum_detail = false
        api.handError.action(this, res);
      });
    },
    getInfoDetail(item) {
      // window.location = '/#/data/com_detail?uni_code=' + item.uni_code
      this.dlg_detail = true
      this.clearData()
      this.ent_item = item
      if (this.ent_item.cid == null) {
        return
      }
      // this.search_patent()
      // this.search_holder()
      // this.search_staff()
      // this.search_copyw()
      // this.search_copyr()
    },
    search_patent() {
      let api_url = '/search/entDetail';
      let para = {
        ...this.p_page
      }
      para.cid = this.ent_item.cid
      para.idx_name = 'patent'
      this.sub_table_loading = true
      api.remote.doPost(para, api_url).then((res) => {
        this.patentList = res.content
        this.p_page.total = res.totalElements
        this.sub_table_loading = false
      }).catch((res) => {
        api.handError.action(this, res);
        this.sub_table_loading = false
      });
    },
    search_holder() {
      let api_url = '/search/entDetail';
      let para = {
        ...this.h_page
      }
      para.cid = this.ent_item.cid
      para.idx_name = 'holder_v2'
      this.sub_table_loading = true
      api.remote.doPost(para, api_url).then((res) => {
        this.holderList = res.content
        this.h_page.total = res.totalElements
        this.sub_table_loading = false
      }).catch((res) => {
        api.handError.action(this, res);
        this.sub_table_loading = false
      });
    },
    search_staff() {
      let api_url = '/search/entDetail';
      let para = {
        ...this.s_page
      }
      para.cid = this.ent_item.cid
      para.idx_name = 'staff'
      this.sub_table_loading = true
      api.remote.doPost(para, api_url).then((res) => {
        this.staffList = res.content
        this.s_page.total = res.totalElements
        this.sub_table_loading = false
      }).catch((res) => {
        api.handError.action(this, res);
        this.sub_table_loading = false
      });
    },
    search_invest() {
      let api_url = '/search/entDetail';
      let para = {
        ...this.i_page
      }
      para.cid = this.ent_item.cid
      para.idx_name = 'invest_v2'
      this.sub_table_loading = true
      api.remote.doPost(para, api_url).then((res) => {
        this.inverstList = res.content
        this.i_page.total = res.totalElements
        this.sub_table_loading = false
      }).catch((res) => {
        api.handError.action(this, res);
        this.sub_table_loading = false
      });
    },
    search_copyw() {
      let api_url = '/search/entDetail';
      let para = {
        ...this.w_page
      }
      para.cid = this.ent_item.cid
      para.idx_name = 'copyw'
      this.sub_table_loading = true
      api.remote.doPost(para, api_url).then((res) => {
        this.copywList = res.content
        this.w_page.total = res.totalElements
        this.sub_table_loading = false
      }).catch((res) => {
        api.handError.action(this, res);
        this.sub_table_loading = false
      });
    },
    search_copyr() {
      let api_url = '/search/entDetail';
      let para = {
        ...this.r_page
      }
      para.cid = this.ent_item.cid
      para.idx_name = 'copyr'
      this.sub_table_loading = true
      api.remote.doPost(para, api_url).then((res) => {
        this.copyrList = res.content
        this.r_page.total = res.totalElements
        this.sub_table_loading = false
      }).catch((res) => {
        api.handError.action(this, res);
        this.sub_table_loading = false
      });
    },
    getHumDetail(row) {
      let postData = {
        index: 0,
        size: 100,
        order: "cnt_v",
      }
      console.log(row)
      if (row.uni_code == null) {
        postData['cid'] = row.cid
      } else {
        postData['uni_code'] = row.uni_code
      }
      // postData['company_name'] = row.company_name
      let api_url = '/slice/humQuery'
      this.loading_info = '加载中...'
      this.dlg_hum_detail_title = row.company_name
      this.dlg_ent_hum_detail = true
      this.humlistLoading = true
      this.ent_hum_list = []
      api.remote.doPost(postData, api_url).then((res) => {

        // 排序
        res.content.sort(function (a, b) {
          function getScore(a) {
            if (a.typeJoin == null) {
              if (a.name == null || a.name == "未知") {
                return 0.0
              } else {
                return 45.0
              }
            }

            let score_a = 0.0
            if (a.typeJoin.some(element => element.includes("副董事长"))) {
              score_a += 40.0
            } else if (a.typeJoin.some(element => element.includes("董事长"))) {
              score_a += 50.0
            } else if (a.typeJoin.some(element => element.includes("董事会"))) {
              score_a += 50.0
            } else if (a.typeJoin.some(element => element.includes("总"))) {
              score_a += 40.0
            } else if (a.typeJoin.some(element => element.includes("经理"))) {
              score_a += 35.0
            } else if (a.typeJoin.some(element => element.includes("法人"))) {
              score_a += 35.0
            } else if (a.typeJoin.some(element => element.includes("负责人"))) {
              score_a += 35.0
            } else if (a.typeJoin.some(element => element.includes("股东"))) {
              score_a += 30.0
            } else if (a.typeJoin.some(element => element.includes("独立董事"))) {
              score_a += 9
            } else if (a.typeJoin.some(element => element.includes("董事"))) {
              score_a += 10.0
            } else if (a.typeJoin.some(element => element.includes("监事会主席"))) {
              score_a += 8.0
            } else if (a.typeJoin.some(element => element.includes("监事长"))) {
              score_a += 5.0
            } else if (a.typeJoin.some(element => element.includes("监事"))) {
              score_a += 0.0
            }
            return score_a
          }

          let score_a = getScore(a)
          let score_b = getScore(b)

          if (a.share != null) {
            score_a += parseFloat(a.share.replace("%", ""))
          }
          if (b.share != null) {
            score_b += parseFloat(b.share.replace("%", ""))
          }
          return score_b - score_a
        });
        this.ent_hum_list = res.content
        this.humlistLoading = false
      }).catch((res) => {
        this.humlistLoading = false
        api.handError.action(this, res);
      });
    },
    show_doc(item) {
      this.ent_item = item
      this.dlg_doc = true;
    },

    get_substr(val) {
      if (val == null)
        return
      val = val.replace(";", "；").replace('〓', '')
      var maxLength = 150
      if (val.length < maxLength) {
        return val
      } else {
        let rtn = val.substring(0, maxLength) + "..."
        return rtn
      }
      // var idx = val.length
      // do {
      //   var a = val.lastIndexOf('；')
      //   var b = val.lastIndexOf('。')
      //   idx = a > b ? a : b
      //   if (idx > -1)
      //     val = val.substring(0, idx)
      // } while (idx > maxLength)
      // return val + "。"
    },
    selsChange: function (sels) {
      this.sels = sels;
    }
  },
  filters: {
    formatMoney(num) {
      num = num / 10000
      return num.toString().replace(/\d+/, function (n) {
        return n.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
      }) + "万";
    },
    formatDateTime(time) {
      var date = new Date(time)
      return date.format("yyyy-MM-dd")
    },
    formatGender(gender) {
      if (gender == 'male') {
        return '男'
      } else if (gender == 'female') {
        return '女'
      }
    }
  },
  mounted() {
    var user = api.storage.get('user')
    if (user != null) {
      let roles = api.storage.get('user').roles
      if (roles.indexOf('ADMIN') != -1)
        this.admin = true
      if (roles.indexOf('SYSADMIN') != -1) {
        this.sysAdmin = true
      }
    }
  }
}
</script>
<style scoped>

.index_tableBox__ZadJW td:nth-child(odd) {
  background-color: #f0f7fc;
}

.index_tableBox__ZadJW td {
  border: 1px solid #e4eef6;
  padding: 8px;
  vertical-align: middle;
}


</style>



// WEBPACK FOOTER //
// EntList.vue?21bd2d72